import _typeof from "@babel/runtime/helpers/typeof";

/* eslint-disable no-underscore-dangle */
import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../sagas';
import reducers from '../reducers';

var reduxDevTools = function reduxDevTools() {
  return (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined' ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (func) {
    return func;
  };
};

export default function configureStore() {
  var sagaMiddleware = createSagaMiddleware();
  var store = process.env.NODE_ENV === 'development' ? createStore(reducers, compose(applyMiddleware(sagaMiddleware), reduxDevTools())) : createStore(reducers, compose(applyMiddleware(sagaMiddleware)));
  sagaMiddleware.run(rootSaga);
  return store;
}